import React from 'react';
import './Loading.css';

const Loading = ({ fullScreen = true, size = 'medium', message }) => {
  const sizeClass = `loading__spinner--${size}`;

  if (fullScreen) {
    return (
      <div className="loading loading--fullscreen">
        <div className="loading__content">
          <div className={`loading__spinner ${sizeClass}`}></div>
          {message && <p className="loading__message">{message}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="loading loading--inline">
      <div className={`loading__spinner ${sizeClass}`}></div>
      {message && <p className="loading__message">{message}</p>}
    </div>
  );
};

export default Loading;